export default __webpack_public_path__ + "static/media/martin_adidas.f6d31ab9.jpg";